import { ShieldAlert, Building2, FileWarning, Scale } from "lucide-react";
import Reveal from "./Reveal";

const ITEMS = [
    {
        icon: ShieldAlert,
        title: "Research use only",
        body: "All compounds are supplied strictly for in-vitro laboratory research. They are not therapeutic goods, not supplements, and are not for human or veterinary use under any circumstances.",
    },
    {
        icon: Building2,
        title: "Institutional verification",
        body: "Enquiries are accepted from verified universities, research institutes and registered R&D entities only. Institutional credentials are confirmed before any supply discussion.",
    },
    {
        icon: FileWarning,
        title: "No retail transactions",
        body: "This site displays no pricing and processes no sales. It is an informational catalog — all supply arrangements follow compliance review of each enquiry.",
    },
    {
        icon: Scale,
        title: "Regulatory framing",
        body: "Materials are not listed on the ARTG and are not represented as therapeutic goods. Purchasers are responsible for ensuring their research use complies with applicable Australian law.",
    },
];

export default function Compliance() {
    return (
        <section id="compliance" data-testid="compliance-section" className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
            <Reveal>
                <div className="rounded-3xl border-2 border-amber-300 bg-amber-50 p-8 sm:p-12" data-testid="compliance-callout">
                    <div className="font-jbm text-xs uppercase tracking-[0.25em] text-amber-700 mb-3">04 — Compliance</div>
                    <h2 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight text-amber-900">
                        For laboratory research use only — not for human or veterinary use
                    </h2>
                    <div className="mt-10 grid sm:grid-cols-2 gap-6">
                        {ITEMS.map((item) => (
                            <div key={item.title} className="bg-white/70 border border-amber-200 rounded-2xl p-6">
                                <item.icon className="w-6 h-6 text-amber-700 mb-4" />
                                <h3 className="font-display text-lg font-semibold text-amber-900">{item.title}</h3>
                                <p className="text-sm leading-relaxed text-amber-800/90 mt-2">{item.body}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </Reveal>
        </section>
    );
}
